module.exports = __webpack_public_path__ + "img/VP-ProfiNew_Overview-EVA_1.ec925af7.jpg";